import { Box, Typography } from "@mui/material";

const tabsArr = [
  { icon: null, label: "All", value: "all" },
  {
    icon: "/icons/store-line-icon.svg",
    label: "Products",
    value: "products",
    disabled: true,
  },
  {
    icon: "/icons/toolbox-repair-icon.svg",
    label: "Services",
    value: "services",
    disabled: true,
  },
  {
    icon: "/icons/bowl-food-icon.svg",
    label: "Restaurants",
    value: "restaurants",
    disabled: true,
  },
  {
    icon: "/icons/coupon-icon.svg",
    label: "Coupons",
    value: "coupons",
    disabled: true,
  },
];

const FilterTabs = (props) => {
  const { selectedOrderTabs, setSelectedOrderTabs } = props;

  const handleTabClick = (value) => {
    if (selectedOrderTabs.includes(value)) {
      setSelectedOrderTabs(selectedOrderTabs.filter((v) => v !== value));
    } else {
      setSelectedOrderTabs([...selectedOrderTabs, value]);
    }
  };

  return (
    <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
      {tabsArr.map((tab, index) => (
        <Box
          sx={filterTabsStyles(tab, selectedOrderTabs)}
          onClick={() => handleTabClick(tab.value)}
        >
          {tab.icon && <img src={tab.icon} alt={tab.label} />}
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, lineHeight: "160%" }}
          >
            {tab.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FilterTabs;

const filterTabsStyles = (tab, selectedOrderTabs) => {
  return {
    display: "flex",
    gap: "6px",
    px: "12px",
    py: "6px",
    borderRadius: "800px",
    border: "1px solid rgba(225, 225, 231, 1)",
    backgroundColor: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
    cursor: "pointer",
    width: "max-content",
    transition: "all 0.2s ease",
    ...(selectedOrderTabs.includes(tab.value)
      ? {
          border: "1px solid rgba(37, 124, 109, 1)",
          backgroundColor: "rgba(37, 124, 109, 1)",
          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          "& > img": {
            filter: "brightness(0) invert(1)",
          },
          "& > p": {
            color: "rgba(255, 255, 255, 1)",
          },
        }
      : {}),
    ...(tab.disabled ? { pointerEvents: "none", opacity: 0.5 } : {}),
  };
};
